import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

// internal
import * as services from '../service/permission';
import { AppType } from '../type/permission';
import { usePermissionStore } from 'apps/composer-app/src/store/permission';

const keyPermission = 'permission';

export const getPermission = async (app: AppType) => {
  try {
    const { data, status } = await services.getPermissions(app);
    if (status === 200) {
      usePermissionStore.getState().setPermission(data?.data.permissions, data?.data.owner);
      return data?.data || {};
    }
  } catch (error) {
    const err = error as AxiosError;
    throw err?.response?.data;
  }
};

export const useGetPermission = (app: AppType) => {
  return useQuery([keyPermission], () => getPermission(app), { retry: 1 });
};
